module.exports = __webpack_public_path__ + "img/icon-zap.ecfef0b1.svg";